import {
  Link,
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  useRouteError,
} from "react-router-dom";
import Layout from "../components/Layout";
import AuthorizationError from "../errors/AuthorizationError";
import CreateSchedulePage from "../pages/Chief/CreateSchedulePage";
import ChiefDashboard from "../pages/Chief/Dashboard";
import ScheduleByDoctor from "../pages/Chief/ScheduleByDoctor";
import ScheduleByType from "../pages/Chief/ScheduleByType";
import ScheduleTypeListAux from "../pages/Chief/ScheduleTypeListAux";
import Dashboard from "../pages/Doctor/Dashboard";
import OnDutyRequest from "../pages/Doctor/OnDutyRequest";
import Login from "../pages/Login";
import PasswordReset from "../pages/PasswordReset";
import PasswordResetComplete from "../pages/PasswordResetComplete";
import PasswordResetMail from "../pages/PasswordResetMail";
import Register from "../pages/Register";
import VerifyTokenFaile from "../pages/VerifyTokenFaile";

const top = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />
      <Route path="/password_reset_mail" element={<PasswordResetMail />} />
      <Route path="/password_reset" element={<PasswordReset />} />
      <Route
        path="/password_reset_complete"
        element={<PasswordResetComplete />}
      />
      <Route path="/verify_token_faile" element={<VerifyTokenFaile />} />
      <Route path="/register" element={<Register />} />
      <Route element={<Layout />} errorElement={<ErrorBoundary />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/on_duty_request" element={<OnDutyRequest />} />
        <Route path="/chief_dashboard" element={<ChiefDashboard />} />
        <Route path="/chief_schedule1" element={<ScheduleByType />} />
        <Route path="/chief_schedule2" element={<ScheduleByDoctor />} />
        <Route path="/create_schedule" element={<CreateSchedulePage />} />
        <Route path="/schedule_types" element={<ScheduleTypeListAux />} />
      </Route>
    </>,
  ),
);
function ErrorBoundary() {
  const error = useRouteError();
  console.error(error);
  // Uncaught ReferenceError: path is not defined

  if (
    error instanceof AuthorizationError ||
    (error?.status >= 401 && error?.status <= 404)
  ) {
    return <Navigate replace to="/login" />;
  }
  return (
    <div>
      エラーが発生しました。
      <br />
      <Link to="/">トップへ戻る</Link>
    </div>
  );
}

export default top;
